import { MODEL_KEY } from '../../../model'
import { REDUX_LOCAL_KEY_PREFIX } from '../../../redux/constants/local-key'
import { REMOTE_KEY_PREFIX } from '../../../redux/constants'

export const MEDIA_MODEL_CLASS_NAME = 'Media'

export const MEDIA_MODEL_KEY = {

  ...MODEL_KEY,

  CAPTION: 'caption',
  ALT_TEXT: 'altText',
  URL: 'url',
  TYPE: 'type',
  ASPECT_RATIO: 'aspectRatio',
  HEIGHT: 'height',
  WIDTH: 'width',
  STATUS: 'status',
  THUMBNAIL: 'thumbnail',
  BLUR_HASH: 'blurHash',
  THUMB_HASH: 'thumbHash',

  // Foreign keys
  PROFILE_ID: 'profileId',

  // Local keys
  LOCAL_URI: `${REDUX_LOCAL_KEY_PREFIX}uri`,

  // Remote keys
  REMOTE_BASE64: `${REMOTE_KEY_PREFIX}remoteBase64`
}

export const MEDIA_MODEL_PRIVATE_KEYS = []

export const MEDIA_MODEL_STATUS = {

  // General
  PRIVATE: 1

}

export const MEDIA_MODEL_TYPE = {
  IMAGE: 1,
  VIDEO: 2,
  AUDIO: 3
}

export const NEW_MEDIA_MODEL_TYPE = {
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
  AUDIO: 'AUDIO'
}

export const LEGACY_MEDIA_MODEL_TYPE_TO_NEW_MODEL_TYPE = {
  [MEDIA_MODEL_TYPE.IMAGE]: NEW_MEDIA_MODEL_TYPE.IMAGE,
  [MEDIA_MODEL_TYPE.VIDEO]: NEW_MEDIA_MODEL_TYPE.VIDEO,
  [MEDIA_MODEL_TYPE.AUDIO]: NEW_MEDIA_MODEL_TYPE.AUDIO
}

export const MEDIA_ASPECT_RATIO = {
  VERY_TALL: 'VERY_TALL', // 9:16 - 1080x1920
  TALL: 'TALL', // 4:5 - 1080x1350
  SQUARE: 'SQUARE', // 1:1 - 500x500
  WIDE: 'WIDE' // 16:9 - 1600x900
}

export const MEDIA_ASPECT_RATIO_TO_VALUE = {
  [MEDIA_ASPECT_RATIO.VERY_TALL]: 177.7777778,
  [MEDIA_ASPECT_RATIO.TALL]: 125,
  [MEDIA_ASPECT_RATIO.SQUARE]: 100,
  [MEDIA_ASPECT_RATIO.WIDE]: 56.25
}

export const MEDIA_MODEL_SCOPE = {

  /**
   * Only returns the public attributes of the Post.
   * @type {Object}
   */
  defaultScope: {
    attributes: {
      exclude: MEDIA_MODEL_PRIVATE_KEYS
    }
  }

}

export const MEDIA_MODEL_AUDIT = {
  CREATED: 'Media Created',
  UPDATED: 'Media Updated',
  DELETED: 'Media Deleted'
}

export const MEDIA_MODEL_AUDIT_CLASS_NAME = 'MediaAudit'
